<template>
    <div class="row justify-content-end">

        <div class="col-auto">
            <button class="btn btn-outline-secondary btn-lg" @click="$emit('cancel')">
                <i class="fa fa-ban"></i> {{resource('Button_Cancel')}}
            </button>
        </div>

        <div class="col-auto">
            <button class="btn btn-outline-danger btn-lg" :class="{ disabled: !canWrite }" @click="promptUser">
                <i class="fa fa-trash"></i> {{resource('Button_Remove')}}
            </button>
        </div>

        <div class="col-auto">
            <button class="btn btn-primary btn-lg" :class="{ disabled: disableSave }" @click="save" >
                <i class="fa fa-save"></i> {{resource('Button_Save')}}
            </button>
        </div>
        
        <prompt 
            v-if="showPrompt" 
            :title="promptValues.title"
            icon="fa fa-trash"
            :body="promptValues.body"
            
            :buttons="[{ 
                    name: resource('Button_No'), 
                    class: 'btn btn-secondary btn-sm',
                    emit: 'no',
                    icon: 'fa fa-times'
                }, { 
                    name: resource('Button_Yes'), 
                    class: 'btn btn-primary btn-sm',
                    emit: 'yes',
                    icon: 'fas fa-check'
                }]"

            @yes="emitDelete" 
            @hidden="showPrompt = false"
        />

    </div>
</template>

<script>

import resources from '../../../Util/Mixins/resources';
import permissionsMixin from '../Mixins/journey-permissions';

import Prompt from '../../../Components/Util/Prompt.vue';

export default {
    name: 'journey-connection-settings-controls',
    mixins: [resources, permissionsMixin],
    components: {
        Prompt
    },
    methods: {
        save() {
            if(this.canWrite) {
                this.$emit('save');
            }
        },
        emitDelete() {
            if(this.canWrite) {
                this.showPrompt = false;

                this.$nextTick(() => {
                    this.$emit('delete');
                })
            }
        },
        promptUser() {
            if(this.canWrite) {
                this.showPrompt = true;
            }
        }
    },
    computed: {
        promptValues() {
            return this.prompt || {
                title: this.resource('JourneyBuilder_GenericSettings_Delete_Title'),
                body: this.resource('JourneyBuilder_GenericSettings_Delete_Body')
            }
        }
    },
    data() {
        return {
            showPrompt: false
        };
    },
    props: {
        prompt: {
            type: Object,
            default: null
        },
        disableSave: {
            type: Boolean,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped src="../Style/journey-connection-settings-controls.scss">

</style>